// src/firebaseConfig.js
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth, initializeAuth, inMemoryPersistence, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { Capacitor } from '@capacitor/core';



const firebaseConfig = {
  apiKey: 'AIzaSyA-e7mqwRoqbG7t8NOBFfhkvnTj8R1ZDmM',
  authDomain: 'coldwire-f7262.firebaseapp.com',
  projectId: 'coldwire-f7262',
  storageBucket: 'coldwire-f7262.firebasestorage.app',
  messagingSenderId: '1083846660352',
  appId: '1:1083846660352:web:70e31c7a2f377f0732a3e5',
  measurementId: 'G-F70FBQCLZP',
};

// Initialize exactly once (avoid duplicate app instances)
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Create ONE Firestore instance and export it
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});

// Keep existing imports working (alias)
export const firestore = db;

let auth;

// iOS / Android Capacitor — use safe memory persistence (localStorage is blocked)
if (Capacitor.isNativePlatform()) {
  console.log("📱 Using in-memory persistence for native platform");
  auth = initializeAuth(app, {
    persistence: inMemoryPersistence,
  });
}

// Web — use browserLocalPersistence
else {
  console.log("🌐 Using browser local persistence");
  auth = getAuth(app);

  setPersistence(auth, browserLocalPersistence)
    .then(() => console.log("🔒 Web persistence: LOCAL storage enabled"))
    .catch(err => console.error("❌ Failed to set web persistence:", err));
}

export { auth };


export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;

